import React, { useState } from 'react';
import { AdminAnalyticsFilters, MetricResult } from '../../../../types/adminAnalytics.ts';
import {
  getActiveUsersDisclaimer,
  getLastLoginCompareWarning,
  windowDaysFromActiveMetricKey,
} from '../../../../utils/adminAnalyticsActiveUsers.ts';
import AnalyticsKpiCard from './AnalyticsKpiCard.tsx';
import AnalyticsUserActivityModal from './AnalyticsUserActivityModal.tsx';
import styles from './AnalyticsActiveUsersBlock.module.scss';

interface AnalyticsActiveUsersBlockProps {
  metrics: MetricResult[];
  filters: AdminAnalyticsFilters;
  compareTo?: string;
}

const AnalyticsActiveUsersBlock: React.FC<AnalyticsActiveUsersBlockProps> = ({
  metrics,
  filters,
  compareTo,
}) => {
  const [selectedMetric, setSelectedMetric] = useState<MetricResult | null>(null);

  if (!metrics.length) return null;

  const selectedWindowDays = selectedMetric
    ? windowDaysFromActiveMetricKey(selectedMetric.key)
    : null;

  const compareWarning = getLastLoginCompareWarning(compareTo);

  return (
    <>
      <div className={styles.block}>
        <h4 className={styles.subtitle}>Usuarios activos</h4>
        <p className={styles.disclaimer}>{getActiveUsersDisclaimer()}</p>
        {compareWarning && <p className={styles.warning}>{compareWarning}</p>}
        <p className={styles.hint}>Hacé click en una tarjeta para ver el listado de usuarios.</p>
        <div className={styles.kpiGrid}>
          {metrics.map((metric) => (
            <AnalyticsKpiCard
              key={metric.key}
              metric={{ ...metric, dimensions: {} }}
              onClick={() => setSelectedMetric(metric)}
            />
          ))}
        </div>
      </div>

      {selectedMetric && selectedWindowDays != null && (
        <AnalyticsUserActivityModal
          isOpen={true}
          onClose={() => setSelectedMetric(null)}
          metricLabel={selectedMetric.label}
          windowDays={selectedWindowDays}
          filters={filters}
          compareTo={compareTo}
        />
      )}
    </>
  );
};

export default AnalyticsActiveUsersBlock;
